import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { AdminauditExportComponent } from '../adminaudit-export/adminaudit-export.component';
import { AdminauditlogRevisionsComponent } from '../adminauditlog-revisions/adminauditlog-revisions.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component,Input } from '@angular/core';

@Component({
  selector: 'app-admincategory-subcategory-auditlog',
  templateUrl: './admincategory-subcategory-auditlog.component.html',
  styleUrls: ['./admincategory-subcategory-auditlog.component.scss']
})
export class AdmincategorySubcategoryAuditlogComponent {
  @Input() public Content: any;
  subGetAuditLogDetailsList: SubscriptionLike;
  subGetAuditLogDetailsList1: SubscriptionLike;

  gridApi: GridApi;
  selectedRow: any;
  columnDefs: any;
  rowData: any = [];
  operations;
  public content: any;
  Catagory_type: string;
  searchdata: any;
  log_data: any = [];
  details_data: any;
  versionids: any;
  categories: any;
  related_pk_id: string;
  RevisionNo: any;
  revisionDetails: RevisionDetails = new RevisionDetails();
  action: Subject<any> = new Subject();
  gridBar:boolean=false;
  gridOptions: { pagination: boolean; rowSelection: string; rowHeight: number; defaultColDef: { sortable: boolean; suppressNavigable: boolean; cellClass: string; suppressMovable: boolean; }; };
  context: any;
  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public apiService: ApidataRequestService,
  ) { }

  ngOnInit(): void {
    this.gridBar=false;
    this.gridHeaderandActionSettings();
    this.searchdata = this.Content.content.SearchData;
    this.searchdata.VersionID = this.Content.content.ID;
    this.log_data = this.Content.content.log_data;
    this.Catagory_type = this.Content.content.SearchData.Category + ((this.Content.content.SearchData.SubCategory != null && this.Content.content.SearchData.SubCategory != "") ? " - " + this.Content.content.SearchData.SubCategory : "");
    this.subGetAuditLogDetailsList = this.apiService.getDataPost("api/AdminAuditTrail/GetAuditTrailSearchSummary", this.searchdata).subscribe((result) => {
      if (result.Status && result.Data.length > 0) {
        this.rowData = result.Data;
        this.details_data = this.rowData;
        this.RevisionNo = this.rowData.map((item) => item.revision_num)
        //debugger
        this.related_pk_id = this.rowData[0].related_pk_id;
      } else {
        this.rowData = [];
        this.details_data = [];
      }
    });

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,     
      
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
        
      }
    }
    this.context = { componentParent: this };
  }

  ngOnDestroy(): void {
    if (this.subGetAuditLogDetailsList) this.subGetAuditLogDetailsList.unsubscribe();
    if (this.subGetAuditLogDetailsList1) this.subGetAuditLogDetailsList1.unsubscribe();

  }

  gridHeaderandActionSettings() {
    this.columnDefs = [
      { headerName: "Revision #", headerTooltip: "Revision #", field: 'revision_num', sortable: false, resizable: true, tooltipField: 'revision_num' },
      // { headerName: "Section Name", headerTooltip: "Section Name", field: "section_name", sortable: false, resizable: true, tooltipField: "section_name" },
      { headerName: "Name", headerTooltip: "Name", field: "Name", sortable: false, resizable: true, tooltipField: "Name" },
      { headerName: "Field Name", headerTooltip: "Field Name", field: 'field_name', sortable: false, resizable: true, tooltipField: "field_name" },
      { headerName: "Old Value", headerTooltip: "Old Value", field: 'initial_value', sortable: false, resizable: true, tooltipField: "initial_value" },
      { headerName: "New Value", headerTooltip: "New Value", field: 'changed_value', sortable: false, resizable: true, tooltipField: "changed_value" },
      { headerName: "Changed On", headerTooltip: "Changed On", field: 'last_modified_date_string', sortable: false, resizable: true, tooltipField: "last_modified_date_string" },
      { headerName: "Changed By", headerTooltip: "Changed By", field: 'last_modified_by', sortable: false, resizable: true, tooltipField: "last_modified_by" }
    ];
  }


  onSetGridApi(params) {
    this.gridApi = params.api;;
    this.gridApi.sizeColumnsToFit();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  OnRevisionClick() {
    this.searchdata.cDetails = "v";
    this.searchdata.cComp = "c";
    this.searchdata.related_pk_id = this.related_pk_id;
    this.searchdata.StartDate = null;
    this.searchdata.EndDate = null;
    var heading = "";
    let modalRef1 = this.modalService.open(AdminauditlogRevisionsComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef1.componentInstance.Content ={
      heading: heading,
      content: {
        ID: null,
        OperationType: "View",
        search_data: this.searchdata,
        RevisionNo: this.RevisionNo
      }
    }
    modalRef1.result.then((result) => {
     
      this.details_data = [];
      this.versionids = [];
      this.categories = [];
      this.log_data = [];
      if (result != null) {
        for (var i = 0; i < result.length; i++) {
          var id = result[i]["versionID"].toString();
          var cat = result[i]["category"].toString();
          this.versionids.push(id);
          this.categories.push(cat);
          //debugger;
          this.revisionDetails = new RevisionDetails();
          this.revisionDetails.revision_num = result[i]["revision_num"];
          this.revisionDetails.last_modified_date_string = result[i]["last_modified_date_string"];
          this.revisionDetails.last_modfied_by = result[i]["last_modfied_by"];
          this.log_data.push(this.revisionDetails);
        }
        var post = {
          versionIDs: this.versionids,
          categories: this.categories,
        };

        this.rowData = [];
        if (result.length > 0) {
          this.subGetAuditLogDetailsList1 = this.apiService.getDataPost("api/AdminAuditTrail/GetAuditTrailMultiSummary", post).subscribe((res) => {
            if (res.Status) {
              this.rowData = res.Data;
              this.RevisionNo = this.rowData.map((item) => item.revision_num)
              this.details_data = this.rowData;
            } else {
              this.rowData = [];
              this.details_data = [];
            }
          });
        }
      }
    });
   
  }

  cancelmodal() {
    this.Catagory_type = "";
    this.modalRef.dismiss();
  }


  ExportToPDF() {
    let modalRef2 = this.modalService.open(AdminauditExportComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true,
    });
    modalRef2.componentInstance.Content = {
      heading: 'Add',
      content: {
        ID: null,
        OperationType: "View",
        log_data: this.log_data,
        details_data: this.details_data,
        cat_type: this.Catagory_type
      }
    }
    modalRef2.result.then((result) => {
    });

  }
}
export class RevisionDetails {
  revision_num: string;
  last_modified_date_string: string;
  last_modfied_by: string;
}
